import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { ProgressStepperComponent } from 'src/app/shared/components/progress-stepper/progress-stepper.component';
import { PropertyUploadNavigationComponent } from '../property-upload-navigation/property-upload-navigation.component';
import { CheckoutProduct, ProductCardComponent } from './product-card/product-card.component';

export interface StepFourData {
  data: {
    selectedPackage: string;
    minPriceValue: number | null;
    maxPriceValue: number | null;
  };
  nextStep: string;
}

let savedPackage :any = {}

@Component({
  selector: 'app-step-four',
  templateUrl: './step-four.component.html',
  styleUrl: './step-four.component.css',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoDirective,
    ProgressStepperComponent,
    FormsModule,
    ReactiveFormsModule,
    PropertyUploadNavigationComponent,
    ProductCardComponent
  ],
})
export class StepFourComponents implements OnInit {
  @Output() previousButtonClicked = new EventEmitter<void>();
  @Input() Steps: string[] = [];
  @Input() productSelection: CheckoutProduct[] = []
  @Output() saveStepFour = new EventEmitter<CheckoutProduct>();
  selectedProduct?: CheckoutProduct
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      package: ['', Validators.required],
    });
  }
  ngOnInit(): void {
    const isSelected = (product:CheckoutProduct) =>{
        return product.sku === savedPackage?.sku
    }
    this.productSelection = this.productSelection.map(x=>{
      return{
        ...x,
        isSelected: isSelected(x)
      }
    })
    this.selectedProduct = this.productSelection.find(x=>x.isSelected)
    this.form.get('package')?.setValue(this.selectedProduct)
  }

  saveStep() {
    if (this.form.valid) {
      this.saveStepFour.emit(this.form.value.package);
    }
  }

  onProductChange(product: CheckoutProduct) {
    this.selectedProduct = product
    this.form.get('package')?.setValue(product); // Update the form control
    savedPackage = product;
  }
}
